import { defineStore } from 'pinia';

import { MANUSCRIPT_V1_API_URL_PREFIX as URL_PREFIX } from '@/lib/constants/manuscripts/api';
import * as action from '@/lib/constants/manuscripts/store';

const useProjectStore = defineStore(
  'manuscript-project',

  {
    state: () => ({
      projects: [],
      isLoading: false,
    }),

    getters: {
      getProjectById(state) {
        return (projectId) => state.projects.find((project) => project.project_id === projectId);
      },
    },

    actions: {
      async [action.GET_PROJECTS]() {
        // Check cache first
        if (this.projects && this.projects.length > 0) {
          window.console.log('📋 Projects: Using cached data');
          return this.projects;
        }

        this.isLoading = true;

        try {
          const response = await this.appApi(`${URL_PREFIX}/project/`);
          this.projects = response.data.results || [];
          window.console.log('📋 Projects: Fetched', this.projects.length, 'projects');
          return this.projects;
        } catch (error) {
          window.console.error('🏪 Project Store: API call failed', error);
          return [];
        } finally {
          this.isLoading = false;
        }
      },
    },
  },
);

export default useProjectStore;
